// extracted by mini-css-extract-plugin
module.exports = {"root":"GlossIcon_root__K9N5L"};